/*
 * Social stream home page
 */
$(document).ready(function(){
    if($('#home-stream').length){
        $('#home-stream').dcSocialStream({
            feeds: {
                twitter: {
                    id: 'GolfeStTropez',
                    out: 'thumb,text,share',
                    url: base_url + '/twitter.php'
                },
                // rss: {
                //     id: base_url + '/fr/blog/feed',
                //     out: 'intro,thumb,title,text,share',
                //     url: base_url + '/rss.php'
                // },
                facebook: {
                    id: '178551465506909,526871244093821',
                    image_width: 2,
                    url: base_url + '/facebook.php',
                    feed: 'posts' // feed, posts
                    //text: 'contentSnippet',
                },
                // google: {
                //     id: '103727147420550533800',
                //     api_key: 'AIzaSyDPdVe5lgOIeb55Ssq1Xnt-gIOAAcDI8_4'
                // },
                pinterest: {
                    id: 'golfesttropez',
                    url: base_url + '/rss.php' 
                },
                youtube: {
                    id: 'UCy3eJ8pK0Yk1r0CH2IZPuLg',
                    feed: 'uploads',
                    out: 'intro,thumb,title,user,share',
                    api_key: 'AIzaSyDPdVe5lgOIeb55Ssq1Xnt-gIOAAcDI8_4',
                    thumb: 'high'
                },
                instagram: {
                    id: '!756376437',
                    out: 'intro,thumb,user,share',
                    accessToken: '756376437.b9fce67.c9dcbe0242274ddb93e62a041e3b7f11',
                    clientId: 'b9fce67c74c44bc1b0e14742238b8e40',
                    url: base_url + '/instagram.php',
                }
            },
            rotate: {
                delay: 0
            },
            twitterId: 'GolfeStTropez',
            control: false,
            filter: false,
            height: 'auto',
            wall: false,
            cache: true,
            max: 'limit',
            days: 30,
            limit: 1,
            iconPath: theme_url + '/img/social-stream/dcsns-dark/',
            imagePath: theme_url + '/img/social-stream/dcsns-dark/'
        });
    }
});

/*
 * Social stream classic wall
 */
$(document).ready(function(){
    if($('#wall-stream').length){
        $('#wall-stream').dcSocialStream({
            feeds: {
                twitter: {
                    id: 'GolfeStTropez',
                    out: 'thumb,text,share',
                    url: base_url + '/twitter.php'
                },
                rss: {
                    id: base_url + '/fr/feed/blog',
                    out: 'intro,title,text,share',
                    url: base_url + '/rss.php'
                },
                facebook: {
                    id: '178551465506909,526871244093821',
                    image_width: 2,
                    url: base_url + '/facebook.php',
                    feed: 'posts' // feed, posts
                    //text: 'contentSnippet',
                },
                google: {
                    id: '103727147420550533800',
                    api_key: 'AIzaSyDPdVe5lgOIeb55Ssq1Xnt-gIOAAcDI8_4'
                },
                pinterest: {
                    id: 'golfesttropez',
                    url: base_url + '/rss.php'
                },
                youtube: {
                    id: 'UCy3eJ8pK0Yk1r0CH2IZPuLg',
                    feed: 'uploads',
                    out: 'intro,thumb,title,user,share',
                    api_key: 'AIzaSyDPdVe5lgOIeb55Ssq1Xnt-gIOAAcDI8_4',
                    thumb: '0'
                },
                instagram: {
                    id: '!756376437',
                    out: 'intro,thumb,text,user,share',
                    accessToken: '756376437.b9fce67.c9dcbe0242274ddb93e62a041e3b7f11',
                    clientId: 'b9fce67c74c44bc1b0e14742238b8e40',
                    url: base_url + '/instagram.php',
                }
            },
            rotate: {
                delay: 0
            },
            twitterId: 'GolfeStTropez',
            control: false,
            filter: false,
            wall: true,
            cache: true,
            max: 'limit',
            days: 30,
            limit: 3,
            iconPath: theme_url + '/img/social-stream/dcsns-dark/',
            imagePath: theme_url + '/img/social-stream/dcsns-dark/'
        });
    }
});

/*
 * Social stream live page
 */
$(document).ready(function(){
    if($('#live-stream-left').length){
        $('#live-stream-left').dcSocialStream({
            feeds: {
                facebook: {
                    id: '178551465506909,526871244093821',
                    image_width: 2,
                    url: base_url + '/facebook.php',
                    feed: 'posts' // feed, posts
                    //text: 'contentSnippet',
                },
                twitter: {
                    id: 'GolfeStTropez',
                    out: 'intro,text,share',
                    url: base_url + '/twitter.php'
                }
            },
            rotate: {
                delay: 0
            },
            twitterId: 'GolfeStTropez',
            control: false,
            filter: false,
            wall: false,
            height: 0,
            cache: false,
            max: 'limit',
            days: 30,
            limit: 6,
            iconPath: theme_url + '/img/social-stream/dcsns-dark/',
            imagePath: theme_url + '/img/social-stream/dcsns-dark/'
        });
    }
    if($('#live-stream-right').length){
        $('#live-stream-right').dcSocialStream({
            feeds: {
                // facebook: {
                //     id: '526871244093821',
                //     image_width: 2,
                //     url: base_url + '/facebook.php',
                //     feed: 'posts' // feed, posts
                //     //text: 'contentSnippet',
                // },
                pinterest: {
                    id: 'golfesttropez',
                    url: base_url + '/rss.php' 
                },
                youtube: {
                    id: 'UCy3eJ8pK0Yk1r0CH2IZPuLg',
                    feed: 'uploads',
                    out: 'intro,thumb,title,user,share',
                    api_key: 'AIzaSyDPdVe5lgOIeb55Ssq1Xnt-gIOAAcDI8_4',
                    thumb: 'high'
                },
                instagram: {
                    id: '!756376437',
                    out: 'intro,thumb,user,share',
                    accessToken: '756376437.b9fce67.c9dcbe0242274ddb93e62a041e3b7f11',
                    clientId: 'b9fce67c74c44bc1b0e14742238b8e40',
                    url: base_url + '/instagram.php',
                }
            },
            rotate: {
                delay: 0
            },
            twitterId: 'GolfeStTropez',
            control: false,
            filter: false,
            wall: false,
            height: 0,
            cache: true,
            max: 'limit',
            days: 30,
            limit: 3,
            iconPath: theme_url + '/img/social-stream/dcsns-dark/',
            imagePath: theme_url + '/img/social-stream/dcsns-dark/'
        });
    }
});

/*
 * Social stream stream page
 */
$(document).ready(function(){
    if($('#stream-stream').length){
        $('#stream-stream').dcSocialStream({
            feeds: {
                twitter: {
                    id: 'GolfeStTropez',
                    out: 'intro,text,share',
                    url: base_url + '/twitter.php'
                },
                /*rss: {
                id: base_url + '/fr/presta/event_today',
                intro: '',
                out: 'intro,title,thumb,text',
                url: base_url + '/rss_event.php'
            },*/
                // rss: {
                //     id: 'www.hellospot.com/api/ext/v1/ugcs/all',
                //     intro: '',
                //     out: 'intro,thumb,title,text',
                //     url: base_url + '/rss_hellospot.php'
                // },
                facebook: {
                    id: '178551465506909,526871244093821',
                    image_width: 2,
                    url: base_url + '/facebook.php',
                    feed: 'posts' // feed, posts
                    //text: 'contentSnippet',
                },
                google: {
                    id: '103727147420550533800',
                    api_key: 'AIzaSyDPdVe5lgOIeb55Ssq1Xnt-gIOAAcDI8_4'
                },
                // pinterest: {
                //     id: 'golfesttropez',
                //     url: base_url + '/rss.php'
                // },
                youtube: {
                    id: 'UCy3eJ8pK0Yk1r0CH2IZPuLg',
                    feed: 'uploads',
                    out: 'intro,thumb,title,user,share',
                    api_key: 'AIzaSyDPdVe5lgOIeb55Ssq1Xnt-gIOAAcDI8_4',
                    thumb: 'high'
                },
                instagram: {
                    id: '!756376437',
                    out: 'intro,thumb,text,user,share',
                    accessToken: '756376437.b9fce67.c9dcbe0242274ddb93e62a041e3b7f11',
                    clientId: 'b9fce67c74c44bc1b0e14742238b8e40',
                    url: base_url + '/instagram.php',
                }
            },
            rotate: {
                delay: 0
            },
            twitterId: 'GolfeStTropez',
            control: false,
            filter: false,
            wall: false,
            cache: false,
            max: 'limit',
            days: 30,
            limit: 3,
            iconPath: theme_url + '/img/social-stream/dcsns-dark/',
            imagePath: theme_url + '/img/social-stream/dcsns-dark/',
            cstream: 'stream owl-carousel owl-theme owl-stream'
        });
    }
});
